import blogApi from "../utils/api/blogApi";

export async function login(email: string, password: string) {
  const response = await blogApi.post("/auth/login", { email, password });

  const token = response.data.token;

  localStorage.setItem("blog_token", token);
  return token;
}

export function logout() {
  localStorage.removeItem("blog_token");
}

export function getToken() {
  return localStorage.getItem("blog_token");
}